import React from 'react';
import PropTypes from 'prop-types';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

export default class SelectLanguageField extends React.Component {
    constructor(props) {
        super(props);

        this.handleChangeLanguage       = this.handleChangeLanguage.bind(this);
    }

    handleChangeLanguage(event, index, value) {
        this.props.onChange(value);
    }

    render() {
        const style = {
            backgroundColor: '#fff', width: '3em'
        };

        return (
            <SelectField
                style={style}
                value={this.props.value}
                onChange={this.handleChangeLanguage}
                underlineShow={false}
                autoWidth={true}
            >
                <MenuItem key="lang-en" value="en" primaryText="En" />
                <MenuItem key="lang-by" value="by" primaryText="By" />
                <MenuItem key="lang-ru" value="ru" primaryText="Ru" />
            </SelectField>
        );
    }

}

SelectLanguageField.propTypes = {
    value: PropTypes.any,
    onChange: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./assets/src/js/components/controls/SelectLanguageField.jsx